import { __module as label } from '../../../../../_virtual/label.js';
import React__default from 'react';
import PropTypes from 'prop-types';

var hasRequiredLabel;

function requireLabel () {
	if (hasRequiredLabel) return label.exports;
	hasRequiredLabel = 1;
	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = Label;

		var _react = React__default;

		var _react2 = _interopRequireDefault(_react);

		var _propTypes = PropTypes;

		var _propTypes2 = _interopRequireDefault(_propTypes);

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		/**
		 * @ignore
		 * @param {Object} props
		 * @param {InputRangeClassNames} props.classNames
		 * @param {Function} props.formatLabel
		 * @param {string} props.type
		 */
		function Label(props) {
		  var labelValue = props.formatLabel ? props.formatLabel(props.children, props.type) : props.children;

		  return _react2.default.createElement(
		    'span',
		    { className: props.classNames[props.type + 'Label'] },
		    _react2.default.createElement(
		      'span',
		      { className: props.classNames.labelContainer },
		      labelValue
		    )
		  );
		}

		/**
		 * @type {Object}
		 * @property {Function} children
		 * @property {Function} classNames
		 * @property {Function} formatLabel
		 * @property {Function} type
		 */
		Label.propTypes = {
		  children: _propTypes2.default.node.isRequired,
		  classNames: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
		  formatLabel: _propTypes2.default.func,
		  type: _propTypes2.default.string.isRequired
		};
		module.exports = exports['default'];
		
	} (label, label.exports));
	return label.exports;
}

export { requireLabel as __require };
